const promisifySwat = (swat) => ({
    fetchLists: () =>
        new Promise((resolve, reject) =>
            swat.fetchLists({ callbackFn: resolve, errorFn: reject })
        ),
    markListPublic: (lid) =>
        new Promise((resolve, reject) =>
            swat.markListPublic(lid, resolve, reject)
        ),
    generateSharedListURL: (lid) =>
        new Promise((resolve, reject) =>
            swat.generateSharedListURL(lid, resolve, reject)
        ),
    sendListViaEmail: (data) =>
        new Promise((resolve, reject) =>
            swat.sendListViaEmail(data, resolve, reject)
        ),
});

function overrideSwymShareActions(swat) {
    const modalContainer = document.querySelector(".swym-modals-container");
    if (
        !modalContainer ||
        modalContainer.hasAttribute("data-listener-attached")
    )
        return;

    modalContainer.setAttribute("data-listener-attached", "true");
    const swatAsync = promisifySwat(swat);

    modalContainer.addEventListener(
        "click",
        async function (e) {
            const emailShareBtn = e.target.closest(
                ".swym-share-wishlist-email-btn"
            );
            const copyLinkBtn = e.target.closest(
                ".swym-share-wishlist-button.swym-share-copy"
            );

            if (emailShareBtn) {
                e.preventDefault();
                e.stopImmediatePropagation();

                const emailAddress =
                    document.querySelector("#swym-email")?.value.trim() || "";
                const fromName =
                    document.querySelector("#swym-name")?.value.trim() || "";
                const shareNote =
                    document.querySelector("#swym-note")?.value.trim() || "";
                const modalCloseButton =
                    document.querySelector(".swym-close-btn");

                if (!emailAddress) {
                    window.customShowToast(
                        "ShowToast",
                        "Please enter a valid email address."
                    );
                    return;
                }

                emailShareBtn.disabled = true;

                try {
                    const lists = await swatAsync.fetchLists();
                    if (!lists || lists.length === 0)
                        throw new Error("No lists found");

                    const lid = lists[0].lid;
                    const publicRes = await swatAsync.markListPublic(lid);

                    await swatAsync.sendListViaEmail({
                        toEmailId: emailAddress,
                        fromName,
                        note: shareNote,
                        lid: publicRes.lid,
                    });

                    window.customShowToast(
                        "ShowToast",
                        "Wishlist shared successfully!"
                    );
                    if (modalCloseButton) modalCloseButton.click();
                } catch (error) {
                    window.customShowToast(
                        "ShowToast",
                        "Failed to share wishlist via email. Please try again."
                    );
                } finally {
                    emailShareBtn.disabled = false;
                }
            }

            if (copyLinkBtn) {
                e.preventDefault();
                e.stopImmediatePropagation();

                const originalText = copyLinkBtn.innerText;
                copyLinkBtn.innerText = "Copying...";
                copyLinkBtn.disabled = true;
                copyLinkBtn.style.pointerEvents = "none";

                try {
                    const lists = await swatAsync.fetchLists();
                    if (!lists || lists.length === 0)
                        throw new Error("No lists found");

                    const lid = lists[0].lid;
                    await swatAsync.markListPublic(lid);

                    const shareLink = await swatAsync.generateSharedListURL(
                        lid
                    );

                    await navigator.clipboard.writeText(shareLink);
                    window.customShowToast(
                        "ShowToast",
                        "Link copied successfully!"
                    );
                } catch (error) {
                    console.error("Swym Copy Link Error:", error);
                    window.customShowToast(
                        "ShowToast",
                        "Unable to copy the link. Please try again."
                    );
                } finally {
                    copyLinkBtn.innerText = originalText;
                    copyLinkBtn.style.pointerEvents = "auto";
                    copyLinkBtn.disabled = false;
                }
            }
        },
        true
    );
}

function bindSwymWishlistData(swat) {
    const wishlistContainerElement = document.querySelector(
        "#swym-wishlist-render-container"
    );
    const queryParams = swat.utils.getEncodedAsObject(window.location.search);
    swat.ui.renderWishlistInContainer(wishlistContainerElement, queryParams);
}

function initSwymWishlistPage(swat) {
    bindSwymWishlistData(swat);
    overrideSwymShareActions(swat);
}

window.SwymCallbacks = window.SwymCallbacks || [];
window.SwymCallbacks.push(initSwymWishlistPage);
